import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

export const IframeComponent = ({ src, title }) => {
  const iframeRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    const handleResize = () => {
      if (iframeRef.current) {
        const { innerWidth, innerHeight } = window;
        iframeRef.current.style.width = `${innerWidth}px`;
        iframeRef.current.style.height = `${Number(innerHeight - 65)}px`;
      }
    };

    const handleMessage = (event) => {
      // Check if the message is coming from the iframe's window
      if (event.source === iframeRef.current.contentWindow) {
        const messageData = event.data; // The data sent from the iframe
        // Check if the message indicates that the back button was clicked
        if (messageData === "backButtonClicked") {
          // Perform the navigation to your desired React route here
          // For example, using React Router's history object:
          history.push("/");
        }
      }
    };

    // Add the event listener

    handleResize();

    window.addEventListener("message", handleMessage);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("message", handleMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <iframe ref={iframeRef} src={src} title={title} allowFullScreen />;
};
